
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { ITietThi } from "../../../model/respone/tct/ITietThi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eTietThiActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as ITietThi[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as ITietThi | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as ITietThi,
    SAVE_SUCCESS: {} as ITietThi,
    SAVE_ERROR: "",

    DELETE_START: {} as IIdsRequest,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    CHANGE_SELECTED_IDS: {} as number[]
};
export const eTietThiActionIds = generateActionTypeIds(
    eTietThiActionsObj,
    "TIET_THI"
);
export type ITietThiActionTypes = IGenericActionType<
    typeof eTietThiActionsObj,
    "TIET_THI"
>;
